import { Component, h, Prop, State, Listen } from '@stencil/core';
import { ComponentView, MenuTab } from '../../../types/types';

@Component({
  tag: 'rentware-tabs',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RentwareTabs {
  @Prop() tabs: MenuTab[];
  @Prop() onTabsLoaded?: () => void;
  @Prop() component: ComponentView = ComponentView.Checkout;
  @Prop() activeTabId?: string;
  @Prop() fixedStyle?: boolean = false;
  @Prop() onTabClick?: (string) => void;

  @State() selectedTab: HTMLDivElement;

  private tabsContainerWidth: number;
  private tabsContainer: HTMLDivElement;
  private singleTabs: HTMLDivElement[] = [];
  private tabInitialWidth: number = 110;

  componentWillLoad() {
    if (this.component === ComponentView.Config) {
      this.tabInitialWidth = 72;
    }
  }

  componentDidLoad() {
    this.distributeTabs();
    if (!!this.onTabsLoaded) {
      this.onTabsLoaded();
    }
  }

  @Listen('resize', { target: 'window' })
  distributeTabs() {
    this.tabsContainerWidth = this.tabsContainer?.offsetWidth; // all width that we can see
    const numberOfTabs = this.tabs.length;
    const activeTab = this.tabs.findIndex(tab => tab.id === this.activeTabId);

    // case 1 - all tabs need less or equal space than is available
    if (numberOfTabs * this.tabInitialWidth <= this.tabsContainerWidth) {
      //const widthOfTab = Math.floor(this.tabsContainerWidth / numberOfTabs); - preserved in case of revert
      const widthOfTab = this.tabInitialWidth;
      this.singleTabs?.map(item => (item.style.width = widthOfTab + 'px'));

      if (!!this.selectedTab) {
        this.selectedTab.style.left = (activeTab + 0.5) * widthOfTab - 40 + 'px';
      }
    } else {
      // case 2 - all tabs need more space than is available
      const numberOfTabsShown = Math.floor((this.tabsContainerWidth + this.tabInitialWidth * 0.5) / this.tabInitialWidth) - 1;
      const widthOfTab = Math.floor(this.tabsContainerWidth / (numberOfTabsShown + 0.5));
      this.singleTabs?.map(item => (item.style.width = widthOfTab + 'px'));

      if (!!this.selectedTab) {
        this.selectedTab.style.left = (activeTab + 0.5) * widthOfTab - 40 + 'px';
      }
    }
  }

  componentWillUpdate() {
    this.distributeTabs();
  }

  get tabsStyle() {
    let tabsContainer = 'TabsContainer ';

    if (this.fixedStyle) {
      return tabsContainer + this.component + 'Tabs FixedStyle';
    } else {
      return tabsContainer + this.component + 'Tabs';
    }
  }

  get showImage() {
    return this.component === ComponentView.Checkout || this.component === ComponentView.Search;
  }

  get activeTabStyle() {
    if (this.fixedStyle) {
      return 'ActiveTab FixedStyle';
    } else {
      return 'ActiveTab';
    }
  }

  mappedTab = item => {
    const tabTitle = this.activeTabId === item.id ? 'TabTitle ActiveTitle' : 'TabTitle';
    const tabContainer = this.activeTabId === item.id ? 'TabContainer' : 'TabContainer InactiveContainer';

    return (
      <div class={tabContainer} onClick={() => this.onTabClick(item.id)} tabIndex={0} ref={el => this.singleTabs.push(el as HTMLDivElement)}>
        {this.showImage && <rentware-image className="TabImage" src={item.iconUrl} autoSize={true} />}

        <div class={tabTitle}>
          <span class="InnerTabTitle">{item.name}</span>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div class={this.tabsStyle} ref={el => (this.tabsContainer = el as HTMLDivElement)}>
        <div class="TabsContainerInner">
          {this.tabs.length > 1 && this.tabs.map(this.mappedTab)}

          <div class={this.activeTabStyle} ref={el => (this.selectedTab = el as HTMLDivElement)} />
        </div>
      </div>
    );
  }
}
